import { DrawerDivider } from "../../../../layout/RightDrawer.style";
import {
  FEATURES,
  GROUP_TYPE,
  IBroadcastInfo,
  IGroupInfo,
} from "@home-health-notify/domain";
import { OrganizationContext } from "hhn-commons";
import { useContext } from "react";
import { SendEmail } from "./SendEmail";
import { MediaDocumentInfo } from "./MediaDocumentInfo";
import { About } from "./About";
import { CommonGroupInfoWrapper } from "./CommonGroupInfo.style";

export const CommonGroupInfo = ({
  groupInfo,
}: {
  groupInfo: IGroupInfo | IBroadcastInfo;
}) => {
  const { selectedOrgUser } = useContext(OrganizationContext);
  const isBroadcastGroup = groupInfo.groupType === GROUP_TYPE.BROADCAST;
  const canViewInternalInfo =
    selectedOrgUser?.hasAccess(FEATURES.VIEW_GROUP_INTERNAL_INFO) ?? false;
  return (
    <CommonGroupInfoWrapper data-testid="commonGroup-info-component">
      {groupInfo.about && groupInfo.about.length > 0 && (
        <>
          <About groupInfo={groupInfo} />
          <DrawerDivider />
        </>
      )}
      {!isBroadcastGroup && canViewInternalInfo && (
        <>
          <SendEmail />
          <DrawerDivider />
        </>
      )}
      <MediaDocumentInfo mediaList={groupInfo.mediaList || []} />
      <DrawerDivider />
    </CommonGroupInfoWrapper>
  );
};
